<template>
  <ul class="profile-page_profile-menu mb-4">
    <li>
      <router-link :to="{ name: 'profile.settings' }">პარამეტრები</router-link>
    </li>
    <li>
      <router-link :to="{ name: 'profile.changepassword' }"
        >პაროლის შეცვლა</router-link
      >
    </li>
    <li>
      <router-link :to="{ name: 'profile.certificate' }"
        >სერტიფიკატი</router-link
      >
    </li>
    <li>
      <router-link :to="{ name: 'signout' }">გასვლა</router-link>
    </li>
  </ul>
</template>

<script>
export default {};
</script>

<style>
.profile-page_profile-menu {
  list-style: none;
  padding: 0;
  margin: 0;
}
.profile-page_profile-menu li a {
  color: inherit;
  text-decoration: none;
  padding: 0.5rem 1rem;
  display: block;
}
.profile-page_profile-menu li a:hover,
.profile-page_profile-menu li a.router-link-active {
  background-color: #98a5b1;
  color: #fff;
}
</style>